export default {
  translation: {
    // header
    SelectLanguage: "Select Language",
    Discover: "Discover",
    WhyQriend: "Why QRiend?",
    LeaveMark: "Leave a Mark",
    InstallNow: "Install Now",
    Login: "Login",
    Register: "Register",
    LogOut: "Log Out",

    // footer
    HomePage: "Home Page",
    QriendDescFooter:
      "Discover new friendships in social environments, meet safely and modernly!",
    Pages: "Pages",
    PrivacyAndSecurity: "Privacy and Security",
    HomePage: "Home",
    QriendTeam: "Our Team",
    PrivacyPolicy: "Privacy Policy",
    TermsOfUse: "Terms of Use",
    DataSecurity: "Data Security",
    CookiePolicy: "Cookie Policy",
    AccountSecurity: "Account Security",
    LegalConsentAndDisclosureText: "Legal Consent and Disclosure Text",
    ChildSafetyPolicy: "Child Safety Policy",
    PrivacySettingsGuide: "Privacy Settings Guide",
    SuitableForAllDevices: "Compatible with All Devices",
    DownloadNowFooter: "Download Now, Expand Your Social Network!",

    // delete request
    DeleteRequestTitle: "Delete Account Request",
    DeleteAccountQuestion: "Do You Want to Delete Your Account?",
    Username: "Username",
    Password: "Password",
    DeleteReason: "Why do you want to delete your account?",
    UsernamePlaceholder: "Enter your username",
    PasswordPlaceholder: "Enter your password",
    ReasonPlaceholder: "Explain why you want to delete your account...",
    SubmitDeleteRequest: "Submit Delete Request",
    Warning: "Warning",
    WarningMessage: "Account deletion cannot be undone. All your data will be permanently deleted.",
    RequestSubmittedSuccessfully: "Request Submitted Successfully",
    RequestSubmittedMessage: "Your account deletion request has been received. We will get back to you as soon as possible.",
    SendNewRequest: "Send New Request",
    UsernameRequired: "Username is required",
    PasswordRequired: "Password is required",
    ReasonRequired: "Account deletion reason is required",

    // register page
    createAccount: "Create Account",
    createAccountDesc: "Sign up now and start meeting new people!",
    firstname: "First Name",
    lastname: "Last Name",
    username: "Username",
    email: "Email",
    password: "Password",
    gender: "Gender",
    male: "Male",
    female: "Female",
    noGender: "Prefer Not to Say",
    registerMain: "Register",
    registerDesc: "Already have an account?",
    registerLogin: "Login",
    kvkkConsent: "I agree to the KVKK and Privacy Agreements",
    kvkkConsentRequired: "You must agree to the KVKK and Privacy Agreements",
    privacyPolicy: "Privacy Policy",
    termsOfUse: "Terms of Use",

    // Landing Qriend Nedir?
    WhatIsQriend: "What is Qriend?",
    WhatIsQriendDesc:
      "It allows you to meet people in the same place with QR code technology. It offers a modern and secure platform to meet new people in social spaces such as bars, cafes and restaurants.",
    RealProfile: "Real Profile",
    RealProfileDesc: "You only interact with verified real users.",
    InstantMeetingOpportunity: "Instant Meeting Opportunity",
    InstantMeetingOpportunityDesc:
      "You can meet someone you see in the venue by instant messaging.",
    VenueChats: "Venue Chats",
    VenueChatsDesc: "QRiend offers digital socialization in your space.",

    // Landing Nasıl Tanışılır?

    HowtoMeet: "How to Meet People?",
    HowtoMeetDesc:
      "With our app, meeting people in real-time at your current location is now incredibly easy! Here's a step-by-step guide on how to use it;",
    EntryandConnectiontotheSpace: "Enter and Connect to the Venue",
    EntryandConnectiontotheSpaceDesc: "Scan the QR code with your phone",
    EntryandConnectiontotheSpaceDesc2:
      "Log into the app to join the venue's network",
    InSituExploration: "In-Venue Exploration",
    InSituExplorationDesc: "See other users currently in the venue",
    InSituExplorationDesc2: "Browse profiles that interest you",
    CommunicationInitiation: "Communication Initiation",
    CommunicationInitiationDesc:
      "Send messages to people who catch your attention",
    CommunicationInitiationDesc2:
      "Easily connect with someone you made eye contact with",
    CommunicationInitiationDesc3:
      "Join the group chat area of your current location",
    SafeSocialization: "Safe Socialization",
    SafeSocializationDesc: "Get to know each other through mutual messaging",
    SafeSocializationDesc2:
      "You can control or end the conversation at any time",
    SafeSocializationDesc3: "Continue meeting new people in a fun and safe way",

    //   Uygulamayı İndir Bölümü
    DownloadApp: "DOWNLOAD THE APP &",
    DownloadApp2: "START EXPLORING!",
    DownloadAppDesc: "Available on App Store and Google Play!",
    DownloadAppDesc2: "Download for free,",
    DownloadAppDesc3: "discover premium features.",

    // Discover
    DiscoverTitle: "Innovative and Social Platform Facilitating Real Dating",
    DiscoverDesc:
      "Are you tired of endless texting? Wouldn't you like to know that you are in the same place as the people you want to meet in real life? That's exactly why our app is different!",
    DiscoverEp2:
      "Are you ready to verify your presence in our partner venues with QR code technology and meet real people in the same venue?",
    DiscoverEp2Dot: "Friendship Tracking",
    DiscoverEp2DotDesc:
      "Follow profiles you like and discover their favorite places. Take the opportunity to meet new places and new people.",
    DiscoverEp3Dot: "Profile and Venue Likes",
    DiscoverEp3DotDesc:
      "Meet new people and discover your favorite places through the profiles and places you like.",
    DiscoverEp4Dot: "Meet on Location",
    DiscoverEp4DotDesc:
      "Unlike ordinary dating apps, with us everything is real! You can see that you are in the same place as someone you like and meet them immediately.",
    SwiperText: "Convenient Interface",
    SafetyMeet: "Safer and More Fun Meetings",
    RealTimeInteraction: "Real-Time Interaction",
    RealTimeInteractionDesc:
      "Instead of getting lost in the virtual world, meet people who are actually in the same place right now",
    RealTimeInteractionDesc2:
      "Who's at your favorite cafe? See instantly and don't miss the chance to meet",
    RealTimeInteractionDesc3:
      "Thanks to our QR code technology, easily verify the venue you're at",
    SecureAndVerifiedEnvironment: "Secure and Verified Environment",
    SecureAndVerifiedEnvironmentDesc: "Socialize at our partner venues",
    SecureAndVerifiedEnvironmentDesc2:
      "With real location verification, fake profile risk is minimal",
    SecureAndVerifiedEnvironmentDesc3:
      "Discover and share your favorite venues",
    BenefitsForBusinesses: "Benefits for Businesses",
    BenefitsForBusinessesDesc: "Increase your customer traffic",
    BenefitsForBusinessesDesc2:
      "Create an environment with high social interaction",

    // leave-mark
    LeaveMark: "Leave Your Mark",
    LeaveMarkTitle:
      "Leave Your Mark: Expand Your Social Experience and Build Connections at Events",
    LeaveMarkDesc:
      "QRiend's 'Leave Your Mark' feature allows you to expand your social experience at concerts, festivals, conferences, and many other events. Now you can meet new people not just at venues, but at every event you attend.",
    How2Use: "How It Works?",
    How2UseDot1: "Join the Event",
    How2UseDot1Desc: "Go to a concert, festival, conference, or any event",
    How2UseDot1Desc2: "Scan the special QRiend QR code at the event venue",
    How2UseDot1Desc3: "Instantly connect to the event chat",
    How2UseDot2: "Discover Event Participants",
    How2UseDot2Desc: "View other QRiend users attending the same event",
    How2UseDot2Desc2:
      "Track in real-time how many people are active in the event chat",
    How2UseDot2Desc3: "Find people who share your interests",
    How2UseDot3: "Special Interactions",
    How2UseDot3Desc:
      "You can send special emojis to participants who catch your attention",
    How2UseDot3Desc2:
      "Sent emojis appear in the entire chat as 'User A sent a heart emoji to User B'",
    How2UseDot3Desc3:
      "Emoji sending is a premium feature and makes meeting people at events more fun",
    WhereCanIUseIt: "Where Can I Use It?",
    WhereCanIUseItDesc:
      "The easiest way to meet new people in different environments, from cafes to concerts, festivals to restaurants.",
    WhereCanIUseItDot1: "Leave Your Mark at Concerts",
    WhereCanIUseItDot1Desc:
      "Write something that will leave your mark at the concert you attended.",
    WhereCanIUseItDot2: "Leave Your Mark at Cafes",
    WhereCanIUseItDot2Desc:
      "Opportunity to socialize in wide friend circles at cafes or pubs",
    WhereCanIUseItDot3: "Usage in Bars and Nightclubs",
    WhereCanIUseItDot3Desc:
      "Socializing in nightlife, theme nights, and safe meeting opportunities",
    DownloadApp: "Download the Mobile App to Leave Your Mark",

    // downloadPage
    DownloadNowNew: "Download Now and Start",
    DownloadNowNew2: "Meeting New People",
    DownloadNowNew3: "Today!",
    DownloadNowDesc:
      "At every venue you go to, meet new people with just one QR code!",
    SupportPlatforms: "Supported Platforms and Devices",
    SupportPlatformsDesc: "Access from Anywhere",
    SupportPlatformsDesc2: "Mobile Devices",
    SupportPlatformsDescDot: "iOS app (optimized for iPhone and iPad)",
    SupportPlatformsDescDot2: "Android app (All Android phones and tablets)",

    // login ve register
    welcome: "Welcome",
    welcomeDesc:
      "We missed you! Please sign in to catch up on what you've missed.",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot your password?",
    login: "Sign In",
    registerMain: " Sign Up",
    loginDesc: "Don't have an account yet?",
    loginReg: "Sign up",
    createAccount: "Create Account",
    createAccountDesc: "Sign up now and start building new friendships.",
    firstname: "First Name",
    lastname: "Last Name",
    username: "Username",
    gender: "Gender",
    password: "Password (At least 6 characters)",
    register: "Sign Up",
    registerDesc: "Already have an account?",
    registerLogin: "Sign In",
    rememberMe: "Remember Me",
    male: "Male",
    female: "Female",
    noGender: "Prefer not to specify gender",

    // Password Reset - forgotPassword.js
    resetPassword: "Reset Password",
    resetPasswordDesc: "Please enter your email address to request a password reset.",
    emailPlaceholder: "...@qriend.app",
    sending: "Sending...",
    send: "Send",
    userNotFoundError: "No user found with this email address.",
    generalError: "An error occurred, please try again.",
    checkSpamFolder: "*Don't forget to check your spam folder.",

    // Password Reset Confirmation - forgotPasswordConfirm.js
    passwordReset: "Password Reset",
    passwordResetDesc: "Enter the 6-digit code sent to your email and create your new password.",
    verificationCode: "Verification Code",
    codeValidityTime: "Code validity time",
    newPassword: "New Password",
    newPasswordPlaceholder: "Enter your new password",
    confirmPassword: "Confirm Password",
    confirmPasswordPlaceholder: "Confirm your password",
    resettingPassword: "Resetting Password...",
    resetPasswordButton: "Reset Password",
    enterVerificationCode: "Please enter the 6-digit verification code.",
    passwordMinLength: "Password must be at least 6 characters.",
    passwordMismatch: "Passwords do not match!",
    passwordResetSuccess: "Your password has been successfully reset!",
    passwordResetError: "Password could not be reset, please try again.",

    // contact page
    ContactTitle: "Contact",
    ContactSubtitle: "Fill out the form for your questions or feedback.",
    ContactName: "Full Name",
    ContactEmail: "Email",
    ContactMessage: "Your Message",
    ContactNamePlaceholder: "Enter your full name",
    ContactEmailPlaceholder: "example@mail.com",
    ContactMessagePlaceholder: "Write your message",
    ContactSend: "Send",
    ContactSending: "Sending...",
    ContactSuccess: "Form submitted successfully.",
    ContactError: "An error occurred. Please try again.",
  },
};
